import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import plusIconWhite from "../../assets/icons/plus-icon-white.svg";
import { useFolderDropdown } from "../../services/destination/index";
import { useStickyHeader } from "../../shared/hooks/StickyHeader";
import { CircularProgressCustom } from "../../utils/muiCustomTheme";
import "./Destinations.scss";
import DestinationsTableTree from "./DestinationsTableTree";
import { useFilteredAudiences } from "./useFilteredAudiences";
import { useCountryList } from "../../services/okta";
import { useSimulationParams } from "../../shared/hooks/useSimulationParams";

function Destinations() {
  const { headerRef, sentinelRef, isSticky, headerHeight  } = useStickyHeader();
  const navigate = useNavigate();
  const { createLink } = useSimulationParams();

  const { data: countries } = useCountryList();

  const availableCountries = Array.isArray(countries)
      ? countries.map((c: any) => ({
        name: c.name || c.code || '',
        tags: Array.isArray(c.tags) ? c.tags : []
      }))
      : [];


  const { data: dataFolderDropdown, isPending: isPendingDataFolderDropdown } = useFolderDropdown({
    query: {
      country: availableCountries.map(c => ({
        name: c.name,
        tags: c.tags
      }))
    }
  });

  const parseDataFolderDropdown = JSON.parse(dataFolderDropdown?.data || "{}");

  // TODO : NEXT PHASE better asking BE for provide filter by query params

  const {
    filteredData,
  } = useFilteredAudiences({ parseDataFolderDropdown });

  const navigateOnDestination = () => {
    navigate(createLink("/create/destination"));
  };

  if (isPendingDataFolderDropdown) {
    return (
      <Box
        sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}
      >
        <CircularProgressCustom />
      </Box>
    );
  }

  return (
    <div className="destinations">
      <div ref={sentinelRef}></div>
      <div ref={headerRef} className={`create-destination__wrap ${isSticky ? "is-sticky" : ""}`}>
        <div className="destinations__container">
          <div className="destinations__container__btn-wrap">
            <div className="destinations__container__title">Destinations</div>
            <div className="destinations__container__btn-wrap__btn">
              <button type="button" className="btn-primary" onClick={navigateOnDestination}>
                Authorize destination
                <img className="btn-primary__icon" src={plusIconWhite} alt="Create Destination" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <Box className="destinations__container">
        <DestinationsTableTree data={filteredData} stickyTop={headerHeight} />
      </Box>
    </div>
  );
}

export default Destinations;
